



















import { Component } from 'vue-property-decorator';
import VSearchBar from '@/components/items/VSearchBar.vue';
import VNotification from '@/components/items/VNotification.vue';
import VUserAvatar from '@/components/avatar/VUserAvatar.vue';
import VMenuButton from '@/components/menu/VMenuButton.vue';
import authModule from '@/store/modules/common/auth.module';
import Mixin from '@/mixin';

@Component({
  name: 'VTopNav',
  components: { VMenuButton, VUserAvatar, VNotification, VSearchBar }
})
export default class VTopNav extends Mixin {
  get companyName() {
    return authModule.user?.companyName;
  }

  get settingIcon() {
    if (this.$route.name === 'reports') return 'ic-setting';
    else if (this.$route.name === 'report.form') return 'ic-house';
    return '';
  }

  get showBackButton() {
    if (this.$route.name === 'home' && this.isAdmin) return false;
    else if (this.$route.name === 'reports' && !this.isAdmin) return false;
    return true;
  }

  public click() {
    if (this.$route.name === 'reports') {
      this.goTo('report-form');
    } else if (this.$route.name === 'report.form') {
      this.goTo('reports');
    }
  }
}
